export default function classesToSelector(_0x276c4b=''){return'.'+_0x276c4b['trim']()['replace'](/([\.:!\/])/g,'\x5c$1')['replace'](/ /g,'.');}